import { CircularProgress, LinearProgress } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";

export default function Progress({shape="line",size=24,time=2000}){
  /**
   * Show a loader. Currently only support linear
   * The loading by default will show a progress 0% to 100% and it will take 2 seconds.
   * After 2 seconds it will continue spinning.
   */
  var [value,setValue]=useState(0)
  var [finished,set_fihished]=useState(false)
  var start=useRef(new Date().valueOf())
  useEffect(()=>{
    if(time) {
      var interval=setInterval(()=>{
        var now=new Date().valueOf()
        var diff=now-start.current
        if (diff-200>time) {
          // too much time pass start from beginning
          start.current=new Date().valueOf()
          set_fihished(true)
          clearInterval(interval)
        } else {
          setValue(diff/time*100)
        }
      },50)
    }
    return ()=>{clearInterval(interval)}
  },[])
  if(shape=="line") {
  return <LinearProgress variant={
    finished ? 'indeterminate' :
    time ? 'determinate':'indeterminate'} value={value} />
  } else {
     return <CircularProgress 
     size={size}
     variant={
    finished ? 'indeterminate' :
    time ? 'determinate':'indeterminate'} value={value} />
  }
}